export function isEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function isAuMobile(value: string): boolean {
  const digits = value.replace(/[^\d+]/g, "");
  return /^(\+?61|0)4\d{8}$/.test(digits);
}

export function leadError(input: { name: string; email: string; mobile: string; privacy: boolean }): string | null {
  if (!input.name.trim()) return "Name is required.";
  if (!isEmail(input.email)) return "Use a real email address.";
  if (!isAuMobile(input.mobile)) return "Use an Australian mobile, like 0400 777 755.";
  if (!input.privacy) return "Privacy consent is required.";
  return null;
}
